import "./documentation.scss";
import { type FC, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useMediaQuery } from "@onshopfront/components";
import DocumentationPage from "./DocumentationPage";
import DocumentationPageLoading from "./DocumentationPageLoading";
import { Navigation, type NavigationType } from "./Navigation/Navigation";
import { NavigationSearchPopup } from "./Navigation/Search/NavigationSearchPopup";

const Documentation: FC = () => {
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(false);
    const [ navigation, setNavigation ] = useState<NavigationType>({});
    const [ path, setPath ] = useState<Array<string>>([]);
    const [ open, setOpen ] = useState(false);
    const location = useLocation();

    const match = useMediaQuery("(max-width: 768px)");

    useEffect(() => {
        const path = location.pathname.substring(15);

        if(!path) {
            setPath([ "General", "About" ]);

            return;
        }

        setPath(path.replace(/-/g, " ").split("/"));
    }, [ location.pathname ]);

    useEffect(() => {
        setOpen(false);
    }, [ location.pathname, location.hash ]);

    useEffect(() => {
        setLoading(true);

        fetch("/navigation", {
            headers: new Headers({
                "Accept": "application/json",
            }),
        })
            .then(response => {
                setLoading(false);

                if(response.status !== 200) {
                    throw new Error("Could not fetch documentation");
                }

                return response.json();
            })
            .then(result => {
                setError(false);
                setNavigation(result);
            })
            .catch(err => {
                console.error("API Documentation: Error loading navigation", err);
                setError(true);
            });
    }, []);

    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            if(e.key === "/") {
                setOpen(true);
            }
        };

        document.addEventListener("keyup", listener);

        return () => {
            document.removeEventListener("keyup", listener);
        };
    }, []);

    if(loading) {
        return (
            <DocumentationPageLoading />
        );
    }

    if(error) {
        return (
            <div>
                <p>We&apos;ve experienced an error while loading the navigation</p>
            </div>
        );
    }

    return (
        <main id="documentation">
            <Navigation
                navigation={navigation}
                path={path}
                onShowSearch={() => {
                    requestAnimationFrame(() => {
                        setOpen(true);
                    });
                }}
            />
            <DocumentationPage path={path.length ? path : [ "General", "About" ]} hash={location.hash} />
            {!match && (
                <NavigationSearchPopup
                    open={open}
                    setOpen={setOpen}
                    navigation={navigation}
                />
            )}
        </main>
    );
};

export default Documentation;
